var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":"true"},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }